import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Row from 'reactstrap/es/Row';
import Col from 'reactstrap/es/Col';
import Button from 'reactstrap/es/Button';
import { toast } from 'react-toastify';
import { SelectFile } from '@yooink/youtils/es/SelectFile';
import Api from './Api';

export default function LocalizationManager () {
	const [stats, setStats] = useState();
	function updateStat () {
		Api.fetchStats().then((data) => setStats(data.stats));
	}
	useEffect(updateStat, []);

	function loadFile () {
		SelectFile({ accept: 'text/csv', multiple: false }, async (files) => {
			const data = await Api.uploadNewLocale(files[0]);
			if (data.status) {
				toast.success('Localization file applied successfully');
				updateStat();
			} else {
				toast.error(data.message);
			}
		});
	}
	return (
		<div>
			<div className="d_title">Localization control module</div>
			<div className="d_box">
				<Row>
					<Col>
						<Link to="/system/localization/i18n">
							<Button color="link" className="btn_main">System localization</Button>
						</Link>
						<br />
						<pre>
							{JSON.stringify(stats, null, 4)}
						</pre>
						<a href="/api/v2/locale/csv" className="link" download>Download system localization file</a>
						<br />
						<a href="/api/v2/locale/csv?onlyRequired=true" className="link" download>Get a file for newlines</a>
					</Col>
					<Col>
						<h2>Loading the locale</h2>
						<Button onClick={loadFile} color="link" className="btn_main">Upload localization file</Button>
					</Col>
				</Row>
			</div>
		</div>
);
}
